import React, {InputHTMLAttributes, ReactElement, useEffect, useState} from "react";
import {omit} from "ramda";

interface FormIntInputProps {
    hasError?: boolean
    intValue: number | null
    onChange: (x: number | null) => void
}

export function FormIntInput(props: FormIntInputProps & Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'>): ReactElement {
    const hasError = props.hasError ?? false;
    const inputProps = omit(['className', 'hasError', 'intValue', 'onChange'], props);

    const [text, setText] = useState<string>(props.intValue?.toString() ?? "");

    useEffect(()=>{
        setText(props.intValue?.toString() ?? "");
    }, [props.intValue]);

    const updateValue = (x: string) => {
        setText(x);
        try {
            const parsedInt = parseInt(x);
            const newVal = isNaN(parsedInt) ? null : parsedInt;
            props.onChange(newVal);
        } catch (e) {
            // do nothing
        }
    };

    return (
        <input
            {...inputProps}
            value={text}
            onChange={e => updateValue(e.target.value)}
            className={`py-3 pl-4 pr-2 w-full
                        text-sm
                        rounded border border-gray-1 outline-0
                        focus:border-focus
                        ${hasError ? 'border-accent' : ''}`}
        />
    );
}